export default __webpack_public_path__ + "static/media/maven-svg.595c08d6.png";